import { AppShell } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { getSubLinksFrom, MenuItem } from "@/constants/navlinks";
import { HeaderMegaMenu, HeaderTabs } from "@/features/dashboard/_components/Header";
import { useIsMobile } from "@/hooks";

export const Route = createFileRoute("/_private/dashboard/_trucks")({
  component: RouteComponent
});

function RouteComponent() {
  const tabs = getSubLinksFrom(MenuItem.TRUCKS).map((item) => ({
    ...item,
    children: item.label
  }));

  const isMobile = useIsMobile();
  console.log({ isMobile });

  return (
    <>
      <AppShell.Header>
        <HeaderTabs items={tabs} from="/dashboard/caminhoes" />
        {isMobile && <HeaderMegaMenu />}
      </AppShell.Header>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </>
  );
}
